import { Components, Theme } from '@mui/material'

declare module '@mui/material/FormControlLabel' {
  interface FormControlLabelProps {
    'data-is-ai-prefilled'?: boolean
  }
}

export const MuiFormControlLabel: Components<Omit<Theme, 'components'>>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: ({ theme, 'data-is-ai-prefilled': dataIsAiPrefilled }) => ({
      ...theme.typography['body-medium'],
      color: theme.palette.text.default,
      '&:has(.MuiCheckbox-root)': {
        // Negative margin to align left edge of checkbox with left edge of other elements
        marginLeft: theme.spacing(-2),
      },
      '& .MuiFormControlLabel-label.Mui-disabled': {
        color: theme.palette.text.default,
      },
      '&:not(.Mui-disabled) .MuiFormControlLabel-label': {
        backgroundColor: dataIsAiPrefilled ? theme.palette.bg.ai.muted : undefined,
      },
    }),
    asterisk: ({ theme }) => ({
      color: theme.palette.text.danger.default,
    }),
  },
}
